"use client";

import { c as _c } from "react/compiler-runtime";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { defaultContent, isContentEmpty } from "@/ui/admin/tiptap-utils";
import { RichTextEditorLazy } from "../rich-text/rich-text-editor-lazy";
export const TabsRichText = t0 => {
  const $ = _c(7);
  const {
    content,
    idx
  } = t0;
  const isEmpty = isContentEmpty(content);
  const {
    saveSelectedPageSectionField
  } = useStoreBuilderContext();
  const t1 = isEmpty ? defaultContent : content;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["bold", "italic", "alignLeft", "alignCenter", "alignRight", "bulletList"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== idx || $[2] !== saveSelectedPageSectionField) {
    t3 = content_0 => {
      saveSelectedPageSectionField({
        fieldPath: `tabItems.${idx}.content`,
        value: content_0
      });
    };
    $[1] = idx;
    $[2] = saveSelectedPageSectionField;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <RichTextEditorLazy content={t1} toolbarOverrides={t2} onChange={t3} />;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};